<template>
  <div class="productList">
    <breadcrumb v-bind:path2="this.cat2"></breadcrumb>
    <!--select order-->
    <div class="collection-header">
      <div class="filters-toolbar-wrapper">
        <div class="page-width">
          <div class="filters-toolbar__item-child">
            <div class="filter">
              <p>{{ $t('sortBy') }} :</p>
              <el-select v-model="option" placeholder="Please Select sorting method" value="" @change="updateFilter">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end select order-->
    <div v-if="this.isLoading" class="product-listing-container">
      <div class="page-width">
        <div class="loadmore disableBtn">
          <span>{{ $t('loadingProducts')}}</span>
          <i class="loading">
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
          </i>
        </div>
      </div>
    </div>
    <!--列表主题-->
    <div v-else-if="!this.isLoading" class="product-listing-container">
      <div class="page-width">
        <ul>
          <li v-for="(item, index) in list" v-bind:key="index" v-if="!item.IsStopSale">
            <div>
              <productCard v-if='$i18n.locale=="en"'
                v-bind:img="item.Thumbnail"
                v-bind:link="item.link"
                v-bind:name="item.Name"
                v-bind:isPromotion="item.IsPromotion"
                v-bind:price="item.Price"
                v-bind:item="item"
                v-bind:quantity="item.Quantity"
                v-bind:key="index"
              ></productCard>
              <productCard v-if='$i18n.locale=="ch"'
                v-bind:img="item.Thumbnail"
                v-bind:link="item.link"
                v-bind:name="item.Description"
                v-bind:isPromotion="item.IsPromotion"
                v-bind:price="item.Price"
                v-bind:item="item"
                v-bind:quantity="item.Quantity"
                v-bind:key="index"
              ></productCard>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/components/breadcrumb";
import productCard from "./productCard";
import { mapActions, mapState, mapMutations } from 'vuex';
import { CUSTOMER_INFORMATION_URL } from "../api/url"
import axios from "axios";
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../store/modules/cart";

export default {
  name: "category2",
  components: {
    breadcrumb,
    productCard,
  },
  props: {
    cat2: {
      type: String,
    }
  },
  data() {
    return {
      option:"",//下拉框选项值
      //drop down
      options: [{
        value: '1',
        label: 'Alphabetically, A-Z'
      }, {
        value: '2',
        label: 'Alphabetically, Z-A'
      }, {
        value: '3',
        label: 'Price, low to high'
      }],
      recommendedSwiper: {
        slidesPerView: 5, // how many to shoe in a row
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        roundLengths : true,
        spaceBetween: 20,
        breakpoints: {
          320: {
              slidesPerView: 1,
          },
          //when width >= 480
          480:{
              slidesPerView: 2,
          },
          768: {
              slidesPerView: 4,
          },
          //when width >= 640
          990: {
              slidesPerView: 4,
          },
          1200:{
              slidesPerView: 4,
          },
          1280: {
              slidesPerView: 5,
          }
        }
      },
      list: [],
      isLoading: false,
      b2b: false,
    }
  },
  methods: {
    ...mapActions('products',['fetchProductsWithCategory2Id']),
    ...mapActions('products',['fetchB2BProductsWithCategory2Id']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapActions('cart', ['addProductToCart']),
    isOutOfStock(item) {
      if(item.IsOverSaleable) {
        return false;
      }
      return item.StockLevel > 0 ? false : true;
    },
    // Check if b2b items are out of stock so we sort them to the bottom.
    isOutOfStockBusiness(item) {
      let stock = item.StockLevel;
      let masterSoldout = true;
      let innerSoldout = true;

      // map through b2b items and check for proper casing. Add to hash map.
      if (item.MasterInner.length) {
        item.MasterInner.map(b2bCase => {
          let itemStock = stock/b2bCase.ConvertNum;
          if (b2bCase.ProductNum.charAt(item.MasterInner[0].ProductNum.length - 1) === "0") {
            if (itemStock>=1) {
              masterSoldout = false;
            }
          }
          if (b2bCase.ProductNum.charAt(item.MasterInner[0].ProductNum.length - 1) === "2") {
            if (itemStock>=1) {
              innerSoldout = false;
            }
          }
        });
      }

      if (masterSoldout && innerSoldout) {
        return true;
      } else {
        return false;
      }
    },
    updateFilter(value) {
      if(value === '1') {
        this.list = this.list.sort((a,b) => {
          return a.Name[0] > b.Name[0] ? 1 : -1;
        })
      }
      if(value === '2') {
        this.list = this.list.sort((a,b) => {
          return a.Name[0] < b.Name[0] ? 1 : -1;
        })
      }
      if(value === '3') {
        this.list = this.list.sort((a,b) => {
          return a.Price - b.Price;
        })
      }
    },
    fetchSelectedCategory2(id) {
      this.list = [];
      if (this.business || this.b2b) {
        this.isLoading = true;
        this.fetchB2BProductsWithCategory2Id(id)
        .then(res => {
          this.isLoading = false;
          let notSoldout = [];
          let isSoldout = [];
          let catOut = [];
          let catReg = [];
          res.data.map((a)=>{
            if (this.business || this.b2b) {
              if (this.isOutOfStockBusiness(a)) {
                isSoldout.push(a)
              } else {
                notSoldout.push(a);
              }
            } else {
              if (this.isOutOfStock(a)) {
              isSoldout.push(a)
              } else {
              notSoldout.push(a)
              }
            }
          });
          catOut = isSoldout.sort((a,b)=>{
             return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
          });
          catReg = notSoldout.sort((a,b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
          })
          this.list = catReg.concat(catOut);
        })
        .catch(err => {
          console.log('err', err)
        })
      } else {
        this.isLoading = true;
        this.fetchProductsWithCategory2Id(id)
        .then(res => {
          this.isLoading = false;
          let notSoldout = [];
          let isSoldout = [];
          let catOut = [];
          let catReg = [];
          res.data.map((a)=>{
            if (this.isOutOfStock(a)) {
              isSoldout.push(a)
            } else {
              notSoldout.push(a)
            }
          })
          catOut = isSoldout.sort((a,b)=>{
             return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
          });
          catReg = notSoldout.sort((a,b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
          })
          this.list = catReg.concat(catOut);
        })
        .catch(err => {
          console.log('err', err)
        })
      }
    },
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item);
    },
    handleAddToCartFail() {
      alert('no enought product in stock');
    },
    addToCart: function(item) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item);
      }
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({ name: 'productDetails', query: { productNum: product.ProductNum} })
    },
    isB2B() {
      const token = localStorage.getItem('token');
      const config = {
        method: 'get',
        url: CUSTOMER_INFORMATION_URL,
        headers: {
          Authorization: `JWT ${token}`,
        }
      };
      let b2b = axios(config)
      .then( (res) => {
        this.paymentTerm = res.data.PaymentTerm;
        return res.data.IsBusiness;
      })
      return b2b;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated()) {
      this.$store.dispatch('cart/getCart');
    }
      next();
  },
  computed: mapState({
    allCategory2: state => state.products.customCategories,
    allCategory2All: state => state.products.customCategoriesAll,
    allB2BCategory2: state => state.products.customB2BCategories,
    activeProduct: state => state.products.activeProduct,
    product: state => state.products.productDetails[0],
    business: state => state.auth.userDetails.IsBusiness,
  }),
  watch: {
    // when hard refresh b2c
    // allCategory2: function(newVal, oldVal) {
    //   let currentCategory2 = newVal.filter(cat2 => {
    //     return cat2.Name.toLowerCase() === this.cat2.toLowerCase();
    //   });
    //   if (currentCategory2 && !this.business) {
    //     this.fetchSelectedCategory2(currentCategory2[0].ProductCategory2_id, "cat2");
    //   }
    // },
    allCategory2All: function(newVal, oldVal) {
      let currentCategory2 = newVal.filter(cat2 => {
        // console.log('newVal: ', newVal);
        // console.log('this.cat2: ', this.cat2); // current one
        return cat2.Name.toLowerCase() === this.cat2.toLowerCase();
      });
      if (currentCategory2 && !this.business) {
        this.fetchSelectedCategory2(currentCategory2[0].ProductCategory2_id, "cat2");
      }
    },
    // when hard refresh b2b
    allB2BCategory2: function(newVal, oldVal) {
      let currentCategory2 = newVal.filter(cat2 => {
        return cat2.Name.toLowerCase() === this.cat2.toLowerCase();
      });
      this.fetchSelectedCategory2(currentCategory2[0].ProductCategory2_id);
    },
    // when select a category2
    cat2: function(newVal, oldVal) {
      this.option = '';
      let currentCategory2;
      // b2c
      if (!this.business) {
        currentCategory2 = this.allCategory2.filter(cat2 => {
          return newVal === cat2.Name.toLowerCase();
        });
      }
      // b2b
      if (this.business) {
        currentCategory2 = this.allB2BCategory2.filter(cat2 => {
          return newVal === cat2.Name.toLowerCase();
        });
      }
      this.fetchSelectedCategory2(currentCategory2[0].ProductCategory2_id);
    }
  },
  mounted: function() {
    // dispatch b2c, b2b category2
    if (isUserAuthenticated()) {
      this.isB2B()
      .then((res) => {
        if (res) {
          this.b2b = true;
          this.$store.dispatch('products/fetchB2BCustomCategories', res);
        } else {
          this.b2b = false;
          this.$store.dispatch('products/fetchCustomCategories', false);
          this.$store.dispatch('products/fetchCustomCategoriesAll', this.business);
        }
      });
    } else {
      this.b2b = false;
      this.$store.dispatch('products/fetchCustomCategories', false);
      this.$store.dispatch('products/fetchCustomCategoriesAll', this.business);
    }
    this.$root.fetchSelectedCategory2 = this.fetchSelectedCategory2.bind(this);
    // b2c
    let currentCategory2 = this.allCategory2.filter(cat2 => {
      return this.cat2 === cat2.Name.toLowerCase();
    });
    // b2b
    currentCategory2 = this.allB2BCategory2.filter(cat2 => {
      return this.cat2 === cat2.Name.toLowerCase();
    });
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/productList.less";
</style>



// WEBPACK FOOTER //
// src/view/category2List.vue